import { markAllAsRead } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { toastSuccess } from "@/utils";
import { toastApiError } from "@/utils/toastApiError";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useMarkAllAsRead() {
  const queryClient = useQueryClient();

  const refreshData = () => {
    queryClient.invalidateQueries({
      queryKey: [NOTIFICATION_QUERY_KEYS.UNREAD_COUNT],
    });
    queryClient.invalidateQueries({
      queryKey: [NOTIFICATION_QUERY_KEYS.MY_NOTIFICATIONS],
    });
  };

  const { mutate, isPending } = useMutation({
    mutationKey: [NOTIFICATION_QUERY_KEYS.MARK_ALL_AS_READ],
    mutationFn: () => markAllAsRead(),
    onSuccess: (data) => {
      toastSuccess(data.message || "Success");
      refreshData();
    },
    onError: toastApiError,
  });

  return { markAllAsRead: mutate, isPending };
}
